// ### STYLE SCSS ###
import './../../scss/2020/style.scss';
// ### STYLE SCSS ###

import $ from "jquery"
import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initASwap } from './aswap'
import { loadingAnimationStart } from './loadingAnimation';
import ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import ScrollToPlugin from 'gsap/src/ScrollToPlugin'
import DrawSVGPlugin from 'gsap/src/DrawSVGPlugin'
import MorphSVGPlugin from 'gsap/src/MorphSVGPlugin'
import MotionPathPlugin from 'gsap/src/MotionPathPlugin'
import PixiPlugin from 'gsap/src/PixiPlugin'
import SplitText from 'gsap/src/SplitText'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'

// GSAP config
gsap.config({nullTargetWarn:false});
// GSAP plugins
ScrollMagicPluginGsap(ScrollMagic, gsap)
gsap.registerPlugin(ScrollToPlugin, MotionPathPlugin, DrawSVGPlugin, MorphSVGPlugin, SplitText, PixiPlugin)


$(() => {
  // # on ready
  initCommon()
  WCAG.init()
  initASwap()
  loadingAnimationStart()
  
});

$(window).on( "load", ()=> {
  // # on load
});